angular.module('cvsApp').directive("decimalPlaces",function(){
	return {
		link:function(scope,ele,attrs){
			
			ele.bind("keyup",function(e){
				var newVal=$(this).val()+(e.charCode!==0?String.fromCharCode(e.charCode):"");
				if($(this).val().search(/(.*)\.[0-9][0-9]/)===0 && newVal.length>$(this).val().length)
					e.preventDefault();
			});
		}
	}
});


angular.module('cvsApp').directive("limitTo", [function() {
    return {
        restrict: "A",
        link: function(scope, elem, attrs) {
            var limit = parseInt(attrs.limitTo);
            angular.element(elem).on("keypress", function(e) {
                if (this.value.length == limit) return false;
            });
        }
    }
}]);

angular.module('cvsApp').directive('futureDate', [
        function() {
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, element, attrs, ctrl) {
                    function futureDateValidator (date) {
                        if(date.length < 10) {
                            return false;
                        }
                        var pickedDate = new Date(date);
                        var currentDate = new Date();
                        if(pickedDate < currentDate) {
                            ctrl.$setValidity('futureDate', true);
                        }
                        else {
                            ctrl.$setValidity('futureDate', false);   
                        }

                        return date;
                    }
                    ctrl.$parsers.push(futureDateValidator);
                }
            };
        }
    ]);

angular.module('cvsApp').directive('bootstrapSwitch', [
        function() {
            return {
                restrict: 'A',
                require: '?ngModel',
                link: function(scope, element, attrs, ngModel) {
                    element.bootstrapSwitch();
                    element.on('switchChange.bootstrapSwitch', function(event, state) {
                        if (ngModel) {
                           scope.$apply(function() {
                                ngModel.$setViewValue(state);
                            });
                        }
                    });
                    scope.$watch(attrs.ngModel, function(newValue, oldValue) {
                        if (newValue=="ACTIVE") {
                            element.bootstrapSwitch('state', true, true);
                        } else {
                            element.bootstrapSwitch('state', false, true);
                        }
                    });
                }
            };
        }
    ]);


angular.module('cvsApp').directive('tabDirective', ['$location','$rootScope','$stateParams','$compile','$window','PAGE_PATH','cvsAppData','$state',
        function(location,$rootScope,$stateParams,$compile,$window,PAGE_PATH,cvsAppData,$state) {
            return {
                restrict: 'E',
                //template:'<div class="section-filter"><div><div><label ui-sref="CI" ng-class="{on:active.CI}" ng-click="CIC.switchTabs()">Quick Registration</label><label ui-sref="RFR.{{RfrSref}}" ng-class="{on:active.RFR}">Ready For Refill</label><label ui-sref="OP" ng-class="{on:active.OP}">Online Payments</label><label class="ng-class="{on:active.TAP}track lock">Track a Package</label></div></div></div>',
                templateUrl:'../common/views/qrTabTemp.html',
                link: function(scope, element, attrs, ngModel) {
                    PAGE_PATH.paymentLock=true;
                    $rootScope.isMobile = cvsUtility.isMobile();
                    scope.RfrSref = 'RPR';
                    scope.CiSref = 'QR';
                    scope.errorConfig = {
                        alertType: 'error',
                        title :'Enter your info',
                        suppressIcon : false,
                        message:'Before you can track your package you must first enter your date of birth and ZIP code.'
                    };
                    if((scope.title==='CI' ||scope.title==='OP'|| scope.title ==='TAP')){
                        if(!$rootScope.title){
                          $rootScope.title ='RPR';   
                        }
                        if(!$rootScope.ciTitle){
                          $rootScope.ciTitle ='CI';   
                        }
                        scope.CiSref = $rootScope.ciTitle;
                        scope.RfrSref = $rootScope.title;
                    }else if(scope.title==='RCONF'){
                        $rootScope.title ='RPR';
                    }
                    else if(scope.title ==='RR'){
                        $rootScope.ciTitle ='RR';
                        scope.CiSref= $rootScope.ciTitle;
                    }
                    else if(scope.title ==='RPR'){
                        scope.CiSref = $rootScope.ciTitle;
                    }
                    else{
                        scope.RfrSref =scope.title;
                        $rootScope.title = scope.title;  
                    }                                           
                     $compile(element.contents())(scope);                      

                },

                controller: ['$scope', '$rootScope', '$cookies', '$element', 'cvsAppData', 'webTrendsService', 'tokenExpireService', function (scope, $rootScope, $cookies, element, CAD, WTS, TES) {

                    if(CAD.hasOwnProperty('tabData')){
                    scope.tabData = CAD.tabData();
                    }

                    if(cvsUtility.queryMap.tokenId){
                        scope.memberLoggedin = true;
                    }
                    scope.isMemberLoggedin = function(){
                        return cvsUtility.queryMap.tokenId ? true : false;
                    }
                    /*
                     *  SPEC-701: Alert (TLP) authentication - perform Logout using web service
                     */
                    scope.signOut = function(){
                        angular.element('#mydiv').show();
                        var oTokenExpire = {
                            tokenID: CAD.getTokenId()
                        }
                          $rootScope.clearAll();
                          TES.tokenExpire(function(){
                            $rootScope.clearAll();
                            window.location.href = "/wps/portal/specialty?logoff=true";
                          }, oTokenExpire);
                    };

                    /**
                     * SP 06/26/2017 - Personalizerd refills warranty fix
                     * Modified function to handle page navigation
                     * @param param
                     * @param dest
                     */
                    scope.switchTab = function(param, dest) {
                        switch(param) {
                            case 'QR':
                                CAD.setOPTabData({isSelected: false});
                                CAD.setRFRTabData({isSelected: false});
                                CAD.setQRTabData({isSelected: true});
                                CAD.setTAPTabData({isSelected: false});
                                CAD.setROTabData({isSelected: false});
                                break;
                            case 'RFR':
                                CAD.setOPTabData({isSelected: false});
                                CAD.setRFRTabData({isSelected: true});
                                CAD.setQRTabData({isSelected: false});
                                CAD.setTAPTabData({isSelected: false});
                                CAD.setROTabData({isSelected: false});
                                break;
                            case 'OP':
                                CAD.setOPTabData({isSelected: true});
                                CAD.setRFRTabData({isSelected: false});
                                CAD.setTAPTabData({isSelected: false});
                                CAD.setQRTabData({isSelected: false});
                                CAD.setROTabData({isSelected: false});
                                break;
                            case 'RO':
                                CAD.setOPTabData({isSelected: false});
                                CAD.setROTabData({isSelected: true});
                                CAD.setRFRTabData({isSelected: false});
                                CAD.setTAPTabData({isSelected: false});
                                CAD.setQRTabData({isSelected: false});
                                break;
                            case 'TAP':
                                CAD.setOPTabData({isSelected: false});
                                CAD.setRFRTabData({isSelected: false});
                                CAD.setQRTabData({isSelected: false});
                                CAD.setTAPTabData({isSelected: true});
                                CAD.setROTabData({isSelected: false});
                                break;
                        }
                        if(dest){
                            $state.go(dest, {}, { reload: true });
                        }
                    };
                    /**
                    * sankar 29/11/2016 - ITPR015400 - guest refill, injected webTrendsService to this controller
                    * Added this function to add WTS page_name,page_category,event_name and event_category tags
                    */
                    scope.getBalance = function(){
                        if(scope.accBalanceFrom && CAD.contextInfo && CAD.contextInfo.contextInformation==="RFR"){
                            if(scope.accBalanceFrom == 'RPCC'){   
                                /**
                                * sankar 29/11/2016 - ITPR015400 - guest refill, when clicked from refill dashboar injected webTrendsService to this controller
                                * Added this function to add WTS page_name,page_category,event_name and event_category tags
                                */
                                WTS.webTrendsUtag("LINK",{ 
                                    page_name:'online payments',
                                    page_category:'member services',
                                    event_name:'guest payment: dashboard',
                                    event_category:'guest refill'
                                });
                            }else if(scope.accBalanceFrom == 'RO'){
                                /**
                                * sankar 29/11/2016 - ITPR015400 - guest refill when clicked online payment from order review page aded a new scope value accBalanceFrom to find from which page the online payment button is clicked.
                                * Added this function to add WTS page_name,page_category,event_name and event_category tags
                                */
                                WTS.webTrendsUtag("LINK",{ 
                                    page_name:'online payments',
                                    page_category:'member services',
                                    event_name:'guest payment: order review',
                                    event_category:'guest refill'
                                });
                            }
                        }
                        
                        $state.go("account-balance", {}, { reload: true });
                    }

                    scope.toggleSubmenu = function(){
                        event.preventDefault();
                        $rootScope.subMenuVisible = !$rootScope.subMenuVisible;
                        CAD.setOPTabData({isSelected: false});
                        CAD.setRFRTabData({isSelected: true});
                        CAD.setQRTabData({isSelected: false});
                        CAD.setTAPTabData({isSelected: false});
                    }

                }]
            };
        }
    ]);

angular.module('cvsApp').directive('faq', function() {
    return {
        restrict: 'A',
        link: function(scope, elem, attrs) {
            if(attrs.href === '/wps/portal/specialty/common/faq/'){
                elem.on('click', function(e){
                    e.preventDefault();
                    var channel;
                    if(cvsUtility.queryMap.channel.indexOf('Web') !== -1) {
                        channel = 'Web';
                    }
                    var url=CVS.Config.parentHost[channel][cvsUtility.queryMap.env]+attrs.href;
                    window.top.location=createChannelUrl("faqs");
                });
            }
        }
    };
});

angular.module('cvsApp').directive('myEnter', function () {
    return function (scope, element, attrs) {
        element.bind("keydown keypress", function (event) {
            if(event.which === 13) {
                scope.$apply(function (){
                    scope.$eval(attrs.myEnter);
                });

                event.preventDefault();
            }
        });
    };
});

// Directive for footer

angular.module('cvsApp').directive('footerDirective', function(){
    return {
        restrict: 'E',
        templateUrl:'../common/views/footerTemplate.html',
    };
});


angular.module('cvsApp').directive('repeatDone', function() {
    return function(scope, element, attrs) {
        if (scope.$last) {
            scope.$eval(attrs.repeatDone);
        }
    }
})
/**
 * IM5937525 - SP 07/13/2017
 * New directive for showing type ahead when store search returns address suggestions
 */
angular.module('cvsApp').directive('typeaheadFocus', function ($timeout,$rootScope) {
    return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModel) {
      element.bind('click', function () {
         
       if($rootScope.typeaheadStoreListValue){
           var viewValue = $rootScope.typeaheadStoreListValue

           if (ngModel.$viewValue == ' ') {
              ngModel.$setViewValue(null);
            }

           ngModel.$setViewValue(' ');
           if(typeof $rootScope.storeName == 'object'){
                ngModel.$setViewValue($rootScope.storeName.Name || ' ');
            } else {
                ngModel.$setViewValue($rootScope.storeName || ' ');
           }

            }
          });

      scope.emptyOrMatch = function (actual, expected) {
        if (expected == ' ') {
          return true;
        }
        var str = "";
        if(typeof actual === "string"){
         str = actual.replace(/[,.]/g , '');
        }
        return str.indexOf(expected) > -1;
      };
    }
  };
});

angular.module('cvsApp').directive('restrictTo', function() {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var re = RegExp(attrs.restrictTo);
            var exclude = /Backspace|Enter|Tab|Delete|Del|ArrowUp|Up|ArrowDown|Down|ArrowLeft|Left|ArrowRight|Right/;

            element[0].addEventListener('keydown', function(event) {
                if (!exclude.test(event.key) && !((event.keyCode == 65 || event.keyCode == 97) && event.ctrlKey) && !re.test(event.key)) {
                    event.preventDefault();
                }
            });
        }
    }
});
/**
 * IM6426155 - My Account Page Zip Code Number Pad
 * SP 01/29/2018
 */
angular.module('cvsApp').directive('zipCodeRestriction', function() {
    return {
        restrict: 'A',
        link: function (scope, element, attrs) {
            var re = RegExp(attrs.restrictTo);
            var exclude = /Backspace|Enter|Tab|Delete|Del|ArrowUp|Up|ArrowDown|Down|ArrowLeft|Left|ArrowRight|Right/;
            var excludeCodes = /8|13|9|46|38|40|37|39/;

            element[0].addEventListener('keydown', function(event) {
                if ((event.keyCode >= 65 && event.keyCode <= 95)) {
                    event.preventDefault();
                }
            });
        }
    }
});

angular.module('cvsApp').directive('compileTemplate', function($compile, $parse){
        return {
            link: function(scope, element, attr){
                var parsed = $parse(attr.ngBindHtml);
                function getStringValue() { return (parsed(scope) || '').toString(); }

                //Recompile if the template changes
                scope.$watch(getStringValue, function() {
                    $compile(element, null, -9999)(scope);  //The -9999 makes it skip directives so that we do not recompile ourselves
                });
            }
        }
})
angular.module('cvsApp').directive('compile', ['$compile', function ($compile) {
    return function(scope, element, attrs) {
        scope.$watch(
            function(scope) {
                // watch the 'compile' expression for changes
                return scope.$eval(attrs.compile);
            },
            function(value) {
                // when the 'compile' expression changes
                // assign it into the current DOM
                element.html(value);

                // compile the new DOM and link it to the current
                // scope.
                // NOTE: we only compile .childNodes so that
                // we don't get into infinite loop compiling ourselves
                $compile(element.contents())(scope);
            }
        );
    };
}])

angular.module('cvsApp').directive('ngEnter', function() {
     return function (scope, element, attrs) {

            element.bind("keydown keypress", function (event) {
                if (event.which === 13) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngEnter);
                    });

                    event.preventDefault();
                }
            });
        };
});

angular.module('cvsApp').directive('ngSpace', function() {
     return function (scope, element, attrs) {

            element.bind("keydown keypress", function (event) {
                if (event.which === 32) {
                    scope.$apply(function () {
                        scope.$eval(attrs.ngSpace);
                    });

                    event.preventDefault();
                }
            });
        };
});

angular.module('cvsApp').directive('hasFocus', function() {
    return {
        restrict: 'A',
        link: function(scope, element, attrs) {
            element.on('keydown', function(e) {
                switch (e.which) {
                    case 37:
                        $(".move")[0].focus()
                        break;
                    case 39:                        
                        $(".move")[1].focus()
                        break;
                }
            });
        }
    }
});